/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationAttachmentAliases {
  ATTACHMENT_PROVIDER_ACCREDITATION = 'attachment-provider-accreditation',
  DECK_0 = 'deck-0',
  FETCH_ATTACHMENTS = 'fetch-attachments',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  LAYOUT_0 = 'layout-0',
  PANEL_0 = 'panel-0',
  PANEL_PROVIDER_ACCREDITATION_ATTACHMENT = 'panel-provider-accreditation-attachment',
}
export { ProviderAccreditationAttachmentAliases };
